module.exports = __webpack_public_path__ + "img/1-230109150624D8.7cf525ea.jpg";